import FetchSettings from "../../interfaces/FetchSettings";
import { EventCarouselItem } from "../../types/EventCarousel";
import { EventReplay } from "../../types/EventReplay";
import { UpcomingEventsConfiguration } from "../../types/UpcomingEventsConfigurations";
import { EventSearchDefaults } from "../../types/EventSearchDefaults";
import { LeaderboardUser } from "../../types/Leaderboard";
import { Spotlight } from "../../types/Spotlight";
import { TestimonialQuote } from "../../types/TestimonialQuote";
import { TestimonialVideo } from "../../types/TestimonialVideo";
import OcontentProvider from "./OcontentProvider";

export default class OcontentMiscProvider extends OcontentProvider {
  protected _baseUrl = this.baseUrl + "misc/";

  async getLeaderboard(): Promise<Array<LeaderboardUser> | null> {
    try {
      const url = new URL(this._baseUrl + "leaderboard.json");
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      return await res.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async getEventCarousel(): Promise<Array<EventCarouselItem> | null> {
    try {
      const res = await fetch(this._baseUrl + "event-carousel.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getEventReplayListData(): Promise<Array<EventReplay> | null> {
    try {
      const res = await fetch(this._baseUrl + "event-replays.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getSpotlightData(): Promise<Array<Spotlight> | null> {
    try {
      const res = await fetch(this._baseUrl + "spotlights.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getInternalSpotlightData(): Promise<Array<Spotlight> | null> {
    try {
      const res = await fetch(this._baseUrl + "spotlights-internal.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getTestimonialQuoteData(): Promise<Array<TestimonialQuote> | null> {
    try {
      const res = await fetch(this._baseUrl + "testimonials-quotes.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getTestimonialVideoData(): Promise<Array<TestimonialVideo> | null> {
    try {
      const res = await fetch(this._baseUrl + "testimonials-videos.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getEventSearchDefaultsData(): Promise<Array<EventSearchDefaults> | null> {
    try {
      // return [
      //   {
      //     "categoryId": 103,
      //     "defaultKeywords": "\"Sales\"+\"CX\"+\"Content\"",
      //     "defaultAuthors": ["CCC Test User"]
      //   },
      //   {
      //     "categoryId": 101,
      //     "defaultTitle": "HCM",
      //     "defaultKeywords": "\"Learn\"",
      //     "defaultAuthors": ["CCC Test User 01", "CCC Test User 2"]
      //   }
      // ]
      const res = await fetch(this._baseUrl + "event-search.json");
      const json = await res.json();
      return json["items"];
    } catch (err) {
      return null;
    }
  }

  async getUpcomingEventsConfigurations(): Promise<Array<UpcomingEventsConfiguration> | null> {
    try {
      const res = await fetch(this._baseUrl + "events-map.json");
      return await res.json();
    } catch (err) {
      console.error("Error while retrieveing events configurations.");
      return null;
    }
  }
}
